import { render, staticRenderFns } from "./addusers.vue?vue&type=template&id=1f1a4315&scoped=true&"
import script from "./addusers.vue?vue&type=script&lang=js&"
export * from "./addusers.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=1f1a4315&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1a4315",
  null
  
)

export default component.exports